<template>
  <div class="blog-screen">
    <div class="container blog-screen__content">
      <ScreenHeader class="blog-screen__header">
        <template #subtitle>
          {{ subtitle || BLOG_SCREEN_DEFAULTS.subtitle }}
        </template>
        <template #title> {{ title || BLOG_SCREEN_DEFAULTS.title }} </template>
        <!--        <template #text>-->
        <!--          Explore the heart and soul of Speedway Games through our news. Gain insights into our company culture and stay-->
        <!--          updated on the latest developments in our journey!-->
        <!--        </template>-->
      </ScreenHeader>
      <div class="blog-screen__content">
        <div
          class="blog-screen__highlighted-articles"
          v-if="highlightedNews.length"
        >
          <BlogArticleCard
            class="blog-screen__article-card"
            v-for="article in highlightedNews"
            :key="article.id"
            :background-image="article.previewImageUri"
            :published-at="article.publishedAt"
            :title="article.title"
            :views="article.views"
            :url="article.url"
            :type="article.type"
            :extended="true"
            :short-description="article.shortDescription"
            back-to="home"
            data-aos="fade"
          />
        </div>
        <div class="blog-screen__other-articles" v-if="otherNews.length">
          <BlogArticleCard
            class="blog-screen__article-card"
            v-for="article in otherNews"
            :key="article.id"
            :background-image="article.previewImageUri"
            :published-at="article.publishedAt"
            :title="article.title"
            :views="article.views"
            :url="article.url"
            :type="article.type"
            :short-description="article.shortDescription"
            back-to="home"
            data-aos="fade"
          />
        </div>
      </div>
      <Button size="lg" href="/news/"> More News </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import Button from "../buttons/Button.vue";
import Article from "../typography/Article/Article.vue";

  const props = defineProps<{
    title?: string;
    subtitle?: string;
    news: {
      id: number;
      title: string;
      previewImageUri: string;
      publishedAt: Date;
      views: number;
      url: string;
      type: string;
      shortDescription: string;
      highlighted: boolean;
    }[];
  }>();

  const BLOG_SCREEN_DEFAULTS = {
    title: "News",
    subtitle: "Stay in touch",
  };

  const highlightedNews = computed(() =>
    props.news
      .toSorted(
        (a, b) =>
          Number(b.highlighted) - Number(a.highlighted) ||
          new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
      )
      .slice(0, 2)
  );
  const otherNews = computed(() =>
    props.news.filter(article => !highlightedNews.value.some(highlighted => highlighted.id === article.id))
      .toSorted(
        (a, b) =>
          Number(a.highlighted) - Number(b.highlighted) ||
          new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
      )
      .slice(0, 3)
  );
</script>

<style lang="scss">
  .blog-screen {
    //background-image: url("@/assets/images/news-screen-bg.svg");
    //background-size: 100% 100%;
    //background-position: center bottom;
    //background-repeat: no-repeat;

    padding: 64px 0;

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 32px;
    }

    &__header {
      max-width: 512px;
    }

    &__highlighted-articles {
      display: flex;
      align-items: flex-start;
      gap: 32px;

      @media (max-width: $lg) {
        flex-direction: column;
      }

      .blog-screen__article-card {
        flex: 1 0 0;
      }
    }

    &__other-articles {
      display: flex;
      align-items: flex-start;
      gap: 32px;

      @media (max-width: $lg) {
        flex-direction: column;
      }

      .blog-screen__article-card {
        flex: 1 0 0;
      }
    }

    &__articles {
      display: grid;
      gap: 8px;

      width: 100%;
      //height: 512px;

      &_amount {
        &_1 {
          grid-template-columns: 1fr;
        }

        &_2 {
          grid-template-columns: 1fr 1fr;
        }

        &_3 {
          grid-template-columns: 2fr 1fr;
          grid-auto-rows: 1fr 1fr;

          .blog-screen__article-card:first-child {
            grid-area: 1 / 1 / span 2 / span 1;

            @media (max-width: $lg) {
              grid-area: auto;
            }
          }
        }
      }

      @media (max-width: $lg) {
        display: flex;
        flex-direction: column;
      }
    }
  }
</style>
